import { render, staticRenderFns } from "./EmergencyContact.vue?vue&type=template&id=13971577&scoped=true"
import script from "./EmergencyContact.vue?vue&type=script&lang=ts"
export * from "./EmergencyContact.vue?vue&type=script&lang=ts"
import style0 from "./EmergencyContact.vue?vue&type=style&index=0&id=13971577&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13971577",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13971577')) {
      api.createRecord('13971577', component.options)
    } else {
      api.reload('13971577', component.options)
    }
    module.hot.accept("./EmergencyContact.vue?vue&type=template&id=13971577&scoped=true", function () {
      api.rerender('13971577', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/ClientRightSide/EmergencyContact.vue"
export default component.exports